/* eslint-disable import/prefer-default-export,no-new,no-console,prefer-const,no-unused-vars */
import * as types from './mutation_types'
import apiOrders from '@/api/orders'
import apiClient from '@/api/client'
import Cookies from '@/services/cookies'
import { TargetAssociations } from '@/config/constants'

export default {
  /**
  * Получение флага isDraftOrderFlowEnabled для переключения драфта заказа DEV-16832
  */
  fetchDraftOrderFlowEnabled: ({ commit }) => new Promise((resolve, reject) => {
    apiClient.getClientProfile().then(response => {
      commit(types.SET_DRAFT_ORDER_FLOW_ENABLED, response.data.profile.isDraftOrderFlowEnabled)
      resolve(response.data.profile.isDraftOrderFlowEnabled)
    }).catch(error => {
      reject(error)
    })
  }),
  getOrderById: async ({ dispatch }, orderId) => {
    let response
    try {
      response = await apiOrders.getOrder({ orderIds_HU: orderId })
    } catch (error) {
      return Promise.reject(error)
    }

    return response.data
  },
  /**
   * @param {Object}
   * @param {String} orderId айди заказа
   * @description Получение доступных интервалов и каналов подтверждения для заказа
   */
  getConfirmTaskOptions: (
    { dispatch, state, rootState, commit, rootGetters },
    { orderId },
  ) =>
    new Promise((resolve, reject) => {
      apiOrders
        .getConfirmTaskOptions({ orderId_H: orderId })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          // Raven.captureException(error)
          reject(error)
        })
    }),
  /**
   * @param dispatch
   * @param state
   * @param rootState
   * @param commit
   * @param rootGetters
   * @param payload
   * @param {Object} payload.confirmTaskData объект с данными для запроса
   * @param {String} payload.confirmTaskData.orderId_H айди заказа
   * @param {String} payload.confirmTaskData.intervalId_H айди интервала
   * @param {String} payload.confirmTaskData.channelId_H айди заказа
   * @description Выбор канала и интервала подтверждения заказа
   */
  setConfirmTask: (
    { dispatch, state, rootState, commit, rootGetters },
    payload,
  ) =>
    new Promise((resolve, reject) => {
      apiOrders
        .setConfirmTask(payload)
        .then(response => {
          console.log('setConfirmTask response', response)
          resolve(response.body)
        })
        .catch(error => {
          // Raven.captureException(error)
          reject(error.body)
        })
    }),
  /**
   * @param dispatch
   * @param state
   * @param rootState
   * @param commit
   * @param rootGetters
   * @param payload
   * @param {Object} payload.cancelTaskData.orderId_H айди заказа
   * @description Удаление канала и интервала подтверждения заказа
   */
  cancelConfirmTask: (
    { dispatch, state, rootState, commit, rootGetters },
    payload,
  ) =>
    new Promise((resolve, reject) => {
      apiOrders
        .cancelConfirmTask(payload)
        .then(response => {
          console.log('cancelConfirmTask response', response)
          resolve(response.body)
        })
        .catch(error => {
          // Raven.captureException(error)
          reject(error.body)
        })
    }),
  getActiveOrders: async ({ commit }) => {
    let response
    try {
      response = await apiOrders.getOrdersActive()
      commit(types.SET_ACTIVE_ORDERS, response.data.orders)
    } catch (error) {
      return Promise.reject(error)
    } finally {
    }
    return response.data.orders
  },
  /**
   * {
   * "orderId_H": "zVx",
   * "filterIds": [1, 2, 3]
   * }
   */
  getMenuFull: async ({ commit }, payload) => {
    let response
    try {
      response = await apiOrders.postMenuFull(payload)
    } catch (error) {
      return Promise.reject(error)
    } finally {
    }

    return response.data
  },

  getPaymentProcessing: async ({ commit }, payload) => {
    let response
    try {
      response = await apiOrders.getPaymentProcessing(payload)
    } catch (error) {
      return Promise.reject(error)
    } finally {
    }

    return response.data
  },

  addNewOrderToActiveOrders: ({ commit }, order) => {
    commit(types.ADD_NEW_ACTIVE_ORDER, order)
  },

  updateOrderInActiveOrders: ({ commit }, order) => {
    commit(types.UPDATE_ACTIVE_ORDER, order)
  },

  createOrder: async ({ dispatch, state, rootState, commit, rootGetters, getters }, payload) => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    // DEV-11336 механика "коробка в подарок"
    const refSlug = Cookies.get('ref_slug')
    // - DEV-11336 механика "коробка в подарок"
    const orderData = {
      analyticalData: {
        cookie: Cookies.get(),
        utm: params,
        referrer: Cookies.get('document_referrer'),
        host: window.location.hostname,
      },
      // DEV-11336 механика "коробка в подарок"
      ref_slug: refSlug,
      // - DEV-11336 механика "коробка в подарок"
      ...payload,
    }
    if ('promocode' in orderData) {
      orderData.promocode = orderData.promocode || undefined // because the backend doesn't accept null
    }
    // order origin id
    if (orderData.order) {
      orderData.order.order_origin_id = getters.currentOrderOriginId
    } else {
      orderData.order = {
        order_origin_id: getters.currentOrderOriginId,
      }
    }
    // /order origin id

    orderData.isBmiOrder = rootGetters['vcp/currentTarget'] === TargetAssociations.ECONOMY.TARGET ? false : state.isBmiOrder

    // DEV-16960 Назначаем сегмент по аб для автопродлений
    try {
      await apiOrders.postCheckout(orderData)
    } catch (checkoutError) {
      console.error('Checkout error:', checkoutError)
      return Promise.reject(checkoutError)
    }

    try {
      // TODO: https://growfood.atlassian.net/browse/DEV-17359
      const isDraftOrderFlowEnabled = await dispatch('fetchDraftOrderFlowEnabled')

      let response
      if (isDraftOrderFlowEnabled) {
        response = await apiOrders.postOrdersDraft(orderData)
      } else {
        response = await apiOrders.postOrders(orderData)
      }

      await dispatch('client/checkToken', null, { root: true })
      const promocodeResponse = await dispatch('promocode/postOrdersPromocodeApply', {
        orderId: response.data.order.id_H,
        promocode: rootGetters['promocode/promocode'],
      }, {
        root: true,
      })

      if (promocodeResponse?.success) {
        dispatch('promocode/setPromocode', null)
        return {
          ...response.data,
          needUpdate: true,
        }
      } else {
        return response.data
      }
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  },
  createAbstractPseudoOrder: ({ state, rootState }, data) =>
    new Promise((resolve, reject) => {
      apiOrders.createAbstractPseudoOrder(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    }),
  trackOrderFlowClientActivity: ({ rootState, commit, getters, rootGetters }, orderId) =>
    new Promise((resolve, reject) => {
      apiOrders.trackOrderFlowClientActivity({ orderId: orderId }).then(response => {
        resolve(response)
      })
        .catch(error => {
          reject(error.body)
        })
    }),

  setBmiOrder: ({ commit }, bool) => {
    commit(types.SET_BMI_ORDER, bool)
  },

  setPaymentTypes: ({ commit }, arr) => {
    commit(types.SET_PAYMENT_TYPES, arr)
  },
}
